import { IStudyStoreActions } from '@/interfaces/store/study-store/study-store.actions.interface';
import { IStudyStoreMutations } from '@/interfaces/store/study-store/study-store.mutations.interface';
import { BestFitResult } from '@studyportals/bestfit-api-fe-client';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';
import { StudyStoreState } from '../../enums/study-store-state';

export const studyStoreActions = (
	mutations: IStudyStoreMutations,
): IStudyStoreActions => {
	return {
		saveFit(fit: Map<ScoreDeterminantType, BestFitResult>): void {
			mutations.saveFit(fit);
			mutations.setStoreState(StudyStoreState.CALCULATED);

			document.dispatchEvent(new Event('bestfit_fit_saved'));
		},
	};
};
